/* eslint-disable */
import Vue from 'vue';
import plugin from './plugin';

const facebookId = process.env.FACEBOOK_ID;
const firebaseVapidKey = process.env.FIREBASE_VAPIDKEY;
const googleId = process.env.GOOGLE_ID;
const mountPath = '/';
const standalone = true;

Vue.use(plugin, { mountPath, standalone, facebookId, firebaseVapidKey, googleId });

window.vueApp = new Vue({
  el: '#app',
  template: '<student-dashboard />',
});
